import Alpine from 'alpinejs';
import collapse from '@alpinejs/collapse';
import intersect from '@alpinejs/intersect';
import persist from '@alpinejs/persist';
import Components from 'components';
import Plugins from 'plugins';
import Lity from 'lity';

// Initialise Alpine
window.Alpine = Alpine;
Alpine.plugin(collapse);
Alpine.plugin(intersect);
Alpine.plugin(persist);
Alpine.start();

import 'blocks/OTHEDistributors';

/**
 * Get the "real" number of slides in a wrapper.
 */
function getRealSlideCount($wrapper) {
    const $slides = $wrapper.find('.s-track .s-slide[data-index]');
    if (!$slides.length) return 0;

    // If duplicated, you'll have indexes repeating from 0..n-1 twice.
    const maxIndex = Math.max(...$slides.map((_, el) => parseInt(el.getAttribute('data-index'), 10)).get());
    return Number.isFinite(maxIndex) ? (maxIndex + 1) : $slides.length;
}

/**
 * Read the active slide index from a wrapper.
 */
function getActiveIndex($wrapper) {
    const $active = $wrapper.find('.s-track .s-slide[data-active]').first();
    if (!$active.length) return 0;
    const idx = parseInt($active.attr('data-index'), 10);
    return Number.isFinite(idx) ? idx : 0;
}

/**
 * Move a specific slider wrapper to a target index
 */
function goToSlide($wrapper, targetIndex) {
    if (!$wrapper || !$wrapper.length) return;

    const total = getRealSlideCount($wrapper);
    if (!total) return;

    targetIndex = ((targetIndex % total) + total) % total;

    let current = getActiveIndex($wrapper);
    if (current === targetIndex) return;

    const $slider = $wrapper.find('.s-slider').first();
    if (!$slider.length) return;

    let forwardSteps = (targetIndex - current + total) % total;
    let backwardSteps = (current - targetIndex + total) % total;

    if (forwardSteps <= backwardSteps) {
        for (let i = 0; i < forwardSteps; i++) nextSlide($slider);
    } else {
        for (let i = 0; i < backwardSteps; i++) prevSlide($slider);
    }
}

jQuery(function ($) {
    Components.init();
    Plugins.init();

    $('a[data-lity]').on('click', function (e) {
        e.preventDefault();
    });

    if ($('.s-wrapper').length) {
        $(document).on('click', ':not(.clickable).s-slide', function (e) {
            let $track = $(this).parent().closest('.s-track');
            if($track.hasClass('no-click')) {
                return;
            }

            let $active = $track.find('.s-slide[data-active]').first().index();
            let $current = $(this).index();

            if ($active > $current) {
                let $diff = $active - $current;
                for (let i = 0; i < $diff; i++) {
                    prevSlide($(this).parent().closest('.s-slider'))
                }
            } else if ($active < $current) {
                let $diff = $current - $active;
                for (let i = 0; i < $diff; i++) {
                    nextSlide($(this).parent().closest('.s-slider'))
                }
            }
        });

        $(document).on('click', '.s-wrapper .s-dots button', function (e) {
            const $btn = $(this);
            const $wrapper = $btn.closest('.s-wrapper');

            let targetIndex = $btn.data('index');

            if (typeof targetIndex === 'undefined') {
                targetIndex = $btn.parent().find('button').index($btn);
            }

            targetIndex = parseInt(targetIndex, 10);
            if (!Number.isFinite(targetIndex)) return;

            goToSlide($wrapper, targetIndex);

            // Keep Alpine in sync (if this wrapper is an Alpine component)
            const root = $wrapper.get(0);
            if (root && window.Alpine) {
                try {
                    const data = window.Alpine.$data(root);
                    if (data && typeof data.slide !== 'undefined') data.slide = targetIndex;
                } catch (_) {
                    // no alpine data - ignore
                }
            }
        });


        $(document).on('click', '.s-prev', function () {
            prevSlide($(this).closest('.s-wrapper'));
        });

        $(document).on('click', '.s-next', function () {
            nextSlide($(this).closest('.s-wrapper'));
        });

        var startX, endX;
        var isDragging = false;
        var swipeThreshold = 30;

        $(document).on('touchstart', '.s-slider', function (e) {
            startX = e.touches[0].clientX;
        });

        $(document).on('touchmove', '.s-slider', function (e) {
            endX = e.touches[0].clientX;
        });

        $(document).on('touchend', '.s-slider', function (e) {
            let $track = $(this).find('.s-track');

            if ($(window).width() >= 768 && !$track.hasClass('no-click')) {
                if (startX - endX > swipeThreshold) {
                    $(this).parent().closest('.s-wrapper').find('.s-next').trigger('click');
                } else if (endX - startX > swipeThreshold) {
                    $(this).parent().closest('.s-wrapper').find('.s-prev').trigger('click');
                }
            }
        });

        $(document).on('mousedown', '.s-slider', function (e) {
            startX = e.clientX;
            isDragging = true;
        });

        $(document).on('mousemove', '.s-slider', function (e) {
            if (isDragging) {
                endX = e.clientX;
            }
        });

        $(document).on('mouseup', '.s-slider', function (e) {
            let $track = $(this).find('.s-track');
   
            if (isDragging && !$track.hasClass('no-click')) {
                isDragging = false;
                if (startX - endX > swipeThreshold) {
                    $(this).parent().closest('.s-wrapper').find('.s-next').trigger('click');
                } else if (endX - startX > swipeThreshold) {
                    $(this).parent().closest('.s-wrapper').find('.s-prev').trigger('click');
                }
            }
        });
    }

    //show001 - alt slider
    function removeAdditionalActiveSlideClass() {
        $('.show001-alt .slick-slider .slick-slide.slick-active + .slick-slide.slick-active').removeClass('slick-active');
    }
    removeAdditionalActiveSlideClass();
    if ($('.show001-alt').length) {
        $('.show001-alt .slick-slider').on('afterChange', function (event, slick, currentSlide) {
            removeAdditionalActiveSlideClass();
        });
    }

    $('#ajax-search input[name="s"]').on('keyup', debounce(function() {
        let term = $(this).val();
        
        if(term.length == 0) {
            $('#ajax-results').html('');
        } else if(term.length < 3) {
            $('#ajax-results').html('<div class="pt-4 p-2">Type at least 3 characters to search</div>');
        } else {
            $('#ajax-results').html('<div class="pt-4 p-2">Searching...</div>');
            $.ajax({
                type: 'POST',
                url: scriptVars.ajaxUrl,
                dataType: 'json',
                data: {
                    action: 'get_search_results',
                    search: term,
                    nonce: scriptVars.ajaxNonce,
                },
                success: function(response) {
                    let html = '<div class="pt-4 p-2">';
                    if($.isEmptyObject(response.data)) {
                        html += 'No results found';
                    } else {
                        $.each(response.data, function(key, value) {
                            html += '<div><a class="text-link" href="' + value.url + '">' + value.title + '</a></div>';
                        });
                    }
                    $('#ajax-results').html(html);
                },
                error: function(error) {
                    $('#ajax-results').html('<div class="pt-4 p-2">An error occurred, please try again</div>');
                }
            });
        }
    }, 500));
});

function debounce(func, wait) {
    let timeout;
    return function(...args) {
        clearTimeout(timeout);
        timeout = setTimeout(() => func.apply(this, args), wait);
    };
}

function nextSlide($sliderOrWrapper) {
    // Accept either .s-slider or .s-wrapper, normalize to the slider element
    const $slider = $sliderOrWrapper.hasClass('s-slider')
        ? $sliderOrWrapper
        : $sliderOrWrapper.find('.s-slider').first();

    if (!$slider.length) return;

    $slider.find('.s-track').each(function () {
        const $track = jQuery(this);
        const $slides = $track.find('.s-slide');
        const $first = $slides.first();
        const $last = $slides.last();
        const $active = $track.find('.s-slide[data-active]').first();

        if (!$slides.length) return;

        if (!$active.length) {
            $first.attr('data-active', 1);
            return;
        }

        const $next = $active.next('.s-slide');
        if ($next.length) {
            $next.attr('data-active', 1);
        } else {
            $last.attr('data-active', 1);
        }

        $active.removeAttr('data-active');

        if (!$first.hasClass('active')) {
            const index = $first.attr('data-index');
            const html = '<li class="s-slide" data-index="' + index + '">' + $first.html() + '</li>';
            $first.remove();
            $track.append(html);
        }
    });
}

function prevSlide($sliderOrWrapper) {
    // Accept either .s-slider or .s-wrapper, normalize to the slider element
    const $slider = $sliderOrWrapper.hasClass('s-slider')
        ? $sliderOrWrapper
        : $sliderOrWrapper.find('.s-slider').first();

    if (!$slider.length) return;

    $slider.find('.s-track').each(function () {
        const $track = jQuery(this);
        const $slides = $track.find('.s-slide');
        const $first = $slides.first();
        const $last = $slides.last();
        const $active = $track.find('.s-slide[data-active]').first();

        if (!$slides.length) return;

        if (!$active.length) {
            $last.attr('data-active', 1);
            return;
        }

        const $prev = $active.prev('.s-slide');
        if ($prev.length) {
            $prev.attr('data-active', 1);
        } else {
            $last.attr('data-active', 1);
        }

        $active.removeAttr('data-active');

        if (!$last.hasClass('active')) {
            const index = $last.attr('data-index');
            const html = '<li class="s-slide" data-prev data-index="' + index + '">' + $last.html() + '</li>';
            $last.remove();
            $track.prepend(html);
        }
    });
}

// -- Vanilla JS
// -- START SPLITLINES : CN
class SplitLines {
    // Split lines is a custom vanilla JS
    // class that splits the text content
    constructor(obj) {
        if(!obj.element) {
            this.error('No Element Provided');
        }
        this.obj = obj;
    }

    splitLines = (containers) => {
        Array.prototype.forEach.call(containers, (elem) => {
            // ORIGIONAL Script:
                // let split = elem.innerText.split("\n");
                // let result = split.map((splitString) => {
                //     return '<span class="new-line">' + splitString + "</span>";
                // });
            
                // elem.innerHTML = result.join(" ");


            // MODIFIED Script:
            // to handle additional HTML Tags
            let placeholder = '###BR###';
            let htmlContent = elem.innerHTML.replace(/<br\s*\/?>/gi, placeholder);

            let split = htmlContent.split(placeholder);
            let result = split.map((splitString) => {
                return '<span class="new-line">' + splitString.trim() + "</span>";
            });

            // Join the parts back together with <br> tags between them
            elem.innerHTML = result.join('<br>');
        });

        return true;
    }

    init = () => {
        const containers = document.querySelectorAll(this.obj.element);

        if(!containers || containers.length === 0) {
            this.error('No Element Provided');
        }

        this.splitLines(containers);
    }

    error = (message) => {
        console.error(message);
        return false;
    }
}

const splitLines = new SplitLines({'element': '.split-lines'}).init();
// -- END SPLITLINES




const runFormChanges = () => {
    setInterval(() => {
        document.querySelectorAll('.gform_body').forEach((gForm) => {
            let totalField = gForm.querySelector('.input-total-field input');
            
            if(!totalField) { return }
            let totalValidationContainer = gForm.querySelector('.input-total-validation');
            let totalValidation = gForm.querySelector('.input-total-validation input');
            totalValidationContainer.classList.add('hidden');
            
            if(totalField.value === totalValidation.value) {
                return;
            }

            totalValidation.value = totalField.value.replace(/,/g, '');

        });
    }, 400);
}

runFormChanges();